var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBlueFileDownload(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "file-download-line"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M8.66667 7.99967H10.6667L8 10.6663L5.33333 7.99967H7.33333V5.33301H8.66667V7.99967ZM10 2.66634H3.33333V13.333H12.6667V5.33301H10V2.66634ZM2 1.99421C2 1.62904 2.29833 1.33301 2.66567 1.33301H10.6667L13.9998 4.66634L14 13.9947C14 14.3656 13.7034 14.6663 13.3377 14.6663H2.66227C2.29651 14.6663 2 14.3628 2 14.0051V1.99421Z",
    fill: "#8080FF"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlueFileDownload);
export default __webpack_public_path__ + "static/media/blue-file-download.d9d4f3a7153e4f76f422a7ade90d7454.svg";
export { ForwardRef as ReactComponent };